module.exports = __webpack_public_path__ + "img/character_robot.4aaf3a69.svg";